import React from "react";
import classnames from "classnames";
import parse from "html-react-parser";
import PropTypes from "prop-types";
import { useFormContext, useWatch } from "react-hook-form";
import TextInput from "../TextInput";
import RadioButtonCustomBlendInput from "./RadioButtonCustomBlendInput";

import "./radioButtonCustomBlend.scss";

const RadioButtonCustomBlendTextFields = ({ optionValue, custBlendFields, isDisabled, sendDataToParent }) => {
  const { register, getValues, setValue, setFocus } = useFormContext();

  const handleDataFromChild = (data) => {
    sendDataToParent(data);
  }

  return (
    <div className="radio-button-group__text-fields">
      {custBlendFields.map(({ displayedIndexName, defaultWeight, extAcctCode }, nestedIndex) => {
        return (
          <>
            <label key={displayedIndexName+nestedIndex} className="input-cust-blend-label">
              {displayedIndexName}
              <RadioButtonCustomBlendInput sendDataToParent={handleDataFromChild}  key={displayedIndexName+nestedIndex+optionValue} isDisabled={isDisabled} name={`${optionValue}.${extAcctCode}.value`} defaultWeight={defaultWeight}/>
            </label>
            <span className="input-cust-blend-span">%</span>
          </>
        );
      })}
    </div>
  );
  
};

RadioButtonCustomBlendTextFields.propTypes = {
  optionValue: PropTypes.string, 
  custBlendFields: PropTypes.array,
  isDisabled: PropTypes.bool
};

export default RadioButtonCustomBlendTextFields;


